<template lang="html">
  <div id="reschedulingOptionForm">
  	<div id="option-box">
        <!--授業の種類指定-->
        <div class="option-content">
          <label>授業の種類：</label>
          <input
            id="radio-reservation-normal"
            v-model="reservationOption.reservationType"
            type="radio"
            value="通常"
          />
          <label for="radio-reservation-normal">通常授業</label>
          <input
            id="radio-reservation-normal-first"
            v-model="reservationOption.reservationType"
            type="radio"
            value="通常初回"
          />
          <label for="radio-reservation-normal-first">通常初回授業</label>
          <input
            id="radio-reservation-short"
            v-model="reservationOption.reservationType"
            type="radio"
            value="短期"
          />
          <label for="radio-reservation-short">短期講座</label>
          <input
            id="radio-reservation-short"
            v-model="reservationOption.reservationType"
            type="radio"
            value="短期初回"
          />
          <label for="radio-reservation-short-first">短期初回講座</label>
        </div>
        <!--授業の種類指定 終わり-->
        <!--配布物の有無指定-->
        <div class="option-content">
          <label>配布物（確認テスト）等：</label>
          <input
            id="radio-test-false"
            v-model="reservationOption.hasTest"
            type="radio"
            :value="false"
          />
          <label for="radio-test-false">なし</label>
          <input
            id="radio-test-true"
            v-model="reservationOption.hasTest"
            type="radio"
            :value="true"
          />
          <label for="radio-test-true">あり</label>
        </div>
        <!--配布物の有無指定 終わり-->
        <!--連絡事項記入-->
        <div class="option-content">
          <label>授業での連絡事項があれば記入してください（任意）</label>
          <div class="text-area">
            <el-input
              v-model="reservationOption.reservationMessage"
              type="textarea"
              placeholder="連絡事項があれば入力してください"
              rows="3"
            />
          </div>
        </div>
        <!--連絡事項記入 終わり-->
      </div>
      <!--オプション指定部分 終わり-->
  </div>
</template>

<script>
  export default {
    name: 'reschedulingOptionForm',
    props: {
      reservationOption: {
        type: Object,
        default: function () {
          return {
            reservationType: '通常',
            hasTest: false,
            reservationMessage: ''
          }
        }
      }
    }
  }
</script>

<style lang="css" scoped>
  #option-box {
    text-align: center;
    max-width: 510px;
    margin: 10px auto;
    border: solid 1px black;
  }
  .option-content {
    text-align: left;
  }
  .text-area {
    text-align: left;
    margin: 10px auto;
    max-width: 500px;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingOptionForm.vue?70d33bad